<wm-data-entity-view
  *ngIf="this.entity.dataEntityRef && showEntity"
  [entity]="this.entity.dataEntityRef"
></wm-data-entity-view>
